import {
  Box,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

/**
 * @Component OrderLineSkeleton
 */

/**
 * @param {Object} props
 * @param {number} props.columns
 * @param {number} props.rows
 * @returns {JSX.Element}
 */

const OrderLineSkeleton = ({ rows, columns }) => {
  return (
    <Stack>
      <Skeleton
        animation="wave"
        variant="rectangular"
        width={150}
        height={30}
        sx={{
          alignSelf: 'flex-end',
        }}
      />
      <TableContainer
        component={Box}
        sx={{
          maxHeight: '70vh',
        }}
      >
        <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ p: 2 }} component="th" scope="row">
                <Skeleton animation="wave" variant="text" />
              </TableCell>
              {[...Array(columns - 1)].map((i, index) => (
                <TableCell key={index} sx={{ p: 2 }}>
                  <Skeleton fontSize={'.9em'} animation="wave" variant="text" />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(rows)].map((i, index) => (
              <TableRow key={index}>
                <TableCell sx={{ p: 2 }} component="th" scope="row">
                  <Skeleton animation="wave" variant="text" />
                </TableCell>
                {[...Array(columns - 1)].map((i, index) => (
                  <TableCell key={index} sx={{ p: 2 }}>
                    <Skeleton fontSize={'.9em'} animation="wave" variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default OrderLineSkeleton
